import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Activity } from '@activities/interfaces/activity';
import { Enrollment } from '@activities/interfaces/enrollment';
import ToolsHelper from '@core/services/tools.helper';

library.add(faPlus);

@Component({
  name: 'bpc-enrollment-confirmed-modal',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class EnrollmentConfirmedModal extends Vue {
  @Prop(Object) readonly activity: Activity;
  @Prop(Object) readonly activityGroup: Activity;
  @Prop(Array) readonly enrollments: Enrollment[];

  public config: any = {
    id: 'enrollment-confirmed-modal',
    title: this.$t('global.enrollment_confirmed'),
  };

  onOpenModal() {
    this.$bvModal.show(this.config.id);
  }
  onCloseModal() {
    this.$bvModal.hide(this.config.id);
    this.$emit('click-on-close');
  }

  get totalPrice() {
    let totalPrice = 0;
    if (this.enrollments) {
      this.enrollments.forEach(enrollment => {
        totalPrice += enrollment.order ? enrollment.order.total_price : null;
      });
    }
    return totalPrice;
  }
  public formatPrice(value: string) {
    return ToolsHelper.formatPrice(value);
  }
}
